.root { display: grid; gap: 0.75rem; }
.control {
  --picker-size: var(--control-height-md);
  position: relative;
  max-width: 16rem;
}
.control[data-size="sm"] { --picker-size: var(--control-height-sm); }
.control[data-size="lg"] { --picker-size: var(--control-height-lg); }
.control > input[type="text"], .control > input:not([type]) {
  width: 100%;
  padding-inline-start: var(--picker-size);
  font-family: var(--font-mono);
}
.picker {
  position: absolute;
  inset-block-start: var(--control-border-width);
  inset-inline-start: var(--control-border-width);
  width: calc(var(--picker-size) - 2 * var(--control-border-width));
  height: calc(100% - 2 * var(--control-border-width));
  padding: 0.25rem;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  cursor: pointer;
}
.picker::-webkit-color-swatch-wrapper { padding: 0; }
.picker::-webkit-color-swatch { border: 0; border-radius: var(--radius-sm); }
.picker::-moz-color-swatch { border: 0; border-radius: var(--radius-sm); }
.palette { border: 0; padding: 0; margin: 0; display: flex; flex-wrap: wrap; gap: 0.5rem; }
.swatch { display: grid; place-items: center; width: 2rem; height: 2rem; border: 2px solid var(--color-card); border-radius: 50%; background: var(--swatch); color: white; box-shadow: 0 0 0 1px var(--color-border); cursor: pointer; }
.swatch > svg { width: 75%; height: auto; min-width: 0; min-height: 0; }
.swatch[aria-pressed="true"] { box-shadow: 0 0 0 2px var(--color-foreground); }
.swatch:focus-visible, .picker:focus-visible { outline: 3px solid var(--color-focus-ring); outline-offset: 3px; }
.swatch:disabled, .picker:disabled { opacity: 0.5; cursor: not-allowed; }
